module.exports = __webpack_public_path__ + "img/news17_2.987dd5a3.png";